import { Box, Flex, Heading } from '@chakra-ui/react';
import React from 'react';

export const CenteredHeader = ({
	label,
	children,
	description,
}: {
	label: string;
	children: React.ReactNode;
	description?: string;
}) => {
	return (
		<Flex
			flexDir="column"
			alignItems="center"
			gap='10px'
		>
			<Box
				color="#FF3F3F"
				fontSize="12px"
				textTransform="uppercase"
				fontWeight="bold"
				letterSpacing="0.3em"
				pb='10px'
			>
				{label}
			</Box>
			<Heading
				fontSize="40px"
				maxW="700px"
				textAlign="center"
			>
				{children}
			</Heading>
			<Box color="#686868" fontSize="14px" fontWeight="400" maxW="520px" textAlign='center'>
				{description}
			</Box>
		</Flex>
	);
};
